import React from "react";
import { Helmet } from "react-helmet";
import { graphql, StaticQuery } from "gatsby";
import metaIcon from "../assets/metaIcon.png";

const SEO = () => (
  <StaticQuery
    query={graphql`
      query SiteMetadata {
        site {
          siteMetadata {
            url
            title
            description
          }
        }
      }
    `}
    render={({
      site: {
        siteMetadata: { url, title, description, tags }
      }
    }) => (
      <Helmet defaultTitle={title}>
        <html lang="en" />
        <meta
          name="google-site-verification"
          content="Ia4W5vOwCdQDe5IYC8bk4FcqFBJ1NKgpQkb-7VRh6FM"
        />
        <meta name="docsearch:version" content="2.0" />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover"
        />
        <meta name="keywords" content={tags} />
        <meta name="description" content={description} />
        <meta name="robots" content="index, follow" />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={description} />
        <meta property="og:locale" content="en" />
        <meta property="og:site_name" content={title} />
        <meta property="og:image" content={`${url}${metaIcon}`} />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />
        {/*<base target="_blank" href="https://johnflowerbouquet.github.io/" />*/}
      </Helmet>
    )}
  />
);

export default SEO;
